import {type TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {createDivIn, createImgIn, createParagraphIn, setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils.ts'

export class UIMRoomCardView {
    private readonly cardContainer: HTMLDivElement
    private readonly isCardLocked: boolean
    private isSelected: boolean = false
    private readonly onClick: () => void
    private readonly displayInfoAction: () => void

    constructor(container: HTMLDivElement, text: TranslationObject, icon: LobbyImage, isCardLocked: boolean, isMapCard: boolean, onClick: () => void, displayInfoAction: () => void) {
        this.isCardLocked = isCardLocked
        this.onClick = onClick
        this.displayInfoAction = displayInfoAction
        this.cardContainer = createDivIn(container, `item-scroll-cell mobile-room-card ${isMapCard ? 'mobile-room-map-card' : ''}`)
        createImgIn(this.cardContainer, icon, 'item-scroll-cell-image')
        createParagraphIn(this.cardContainer, text, 'item-scroll-cell-text')

        if(isCardLocked) {
            createImgIn(this.cardContainer, LobbyImage.Lock, 'item-scroll-cell-lock')
            this.cardContainer.classList.add('unavailable')
        }

        createImgIn(this.cardContainer, LobbyImage.InfoIcon, 'item-scroll-cell-info-icon-mobile')

        this.createClickInteraction()
    }

    createBanner(text: TranslationObject) {
        const banner = createDivIn(this.cardContainer, 'badge-green badge-sm')
        createParagraphIn(banner, text, '')
    }

    setSelect(isSelected: boolean) {
        this.isSelected = isSelected
        this.cardContainer.classList.toggle('selected', isSelected)
    }

    private createClickInteraction() {
        setElementOnClick(this.cardContainer, () => {
            if(this.isCardLocked || this.isSelected) {
                this.displayInfoAction()
                return
            }

            this.onClick()
        })
    }
}
